import React, { useState, useEffect } from "react";
import {
  Input,
  Form,
  Col,
  Row,
  Button,
  Select,
  Collapse,
  InputNumber,
  DatePicker,
} from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { odata } from "./Helper";
import moment from "moment";

const ErpPosReportTransactionFilter = (props) => {
  const [form] = Form.useForm();
  const [bankSelect, setBankSelect] = useState({
    data: [],
    loading: true,
  });
  const [firmSelect, setFirmSelect] = useState({
    data: [],
    loading: false,
  });

  const [currencySelect, setCurrencySelect] = useState({
    data: [],
    loading: true,
  });

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  useEffect(() => {
    getBanks();
    getCurrencies();
  }, []);

  const getBanks = () => {
    setBankSelect({
      ...bankSelect,
      loading: true,
    });
    RequestHandler.get(`/PosTransaction/AddedBanks?$select=id,name`).then(
      (response) => {
        setBankSelect({
          data: response,
          loading: false,
        });
      }
    );
  };

  const getCurrencies = () => {
    setCurrencySelect({
      ...currencySelect,
      loading: true,
    });
    RequestHandler.get(`/Currency/GetFilterCurrency`).then((response) => {
      setCurrencySelect({
        data: response,
        loading: false,
      });
    });
  };

  const onFinish = (values) => {
    {
      let query = {};

      if (values.bankId) {
        query.bankId = values.bankId;
      }

      if (values.valueDateRange) {
        [query.valueDateStartDate, query.valueDateEndDate] =
          values.valueDateRange;
      }
      if (query.valueDateStartDate) {
        query.valueDateStartDate = moment(query.valueDateStartDate).format(
          "YYYY-MM-DD"
        );

        query.valueDateEndDate = moment(query.valueDateEndDate).format(
          "YYYY-MM-DD"
        );
      }

      if (values.currencyId) {
        query.currencyId = values.currencyId;
      }

      if (props.onFinishFilter) props.onFinishFilter(query);
      // let query = "";
      // const conditions = [];

      // if (values.bankId) {
      //   conditions.push(`posBankId eq ${values.bankId}`);
      // }
      // if (values.valueDateRange) {
      //   const [startDate, endDate] = values.valueDateRange;

      //   conditions.push(odata.dateRange("valueDate", startDate, endDate));
      // }
      // if (values.terminalNumber) {
      //   conditions.push(
      //     odata.contains("terminalNumber", values.terminalNumber)
      //   );
      // }
      // if (values.currencyCode) {
      //   conditions.push(`currencyCode eq '${values.currencyCode}'`);
      // }
      // if (values.operationTypeString) {
      //   conditions.push(
      //     `operationTypeString eq '${values.operationTypeString}'`
      //   );
      // }

      // if (conditions.length !== 0) {
      //   query = conditions.join(" and ");
      // }

      // if (props.onFinishFilter) props.onFinishFilter(query);
    }
  };

  const clearFilter = () => {
    form.resetFields();
    setFirmSelect({ data: [] });

    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };

  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel header="Filtreleme için tıklayınız.">
            <Form
              name="filter"
              form={form}
              initialValues={{
                remember: true,
              }}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row style={{ flexDirection: "row" }}>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="bankId" label="Banka :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="Tümü"
                      loading={bankSelect.loading}
                      filterOption={(input, option) =>
                        option.props.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                    >
                      {bankSelect.data.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="valueDateRange" label="Valör Tarihi :">
                    <DatePicker.RangePicker
                      format="DD.MM.YYYY"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
                {/* <Col xs={24} md={12} lg={6}>
                  <Form.Item name="terminalNumber" label="Terminal No :">
                    <Input />
                  </Form.Item>
                </Col> */}

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="currencyId" label="Para Birimi :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="Tümü"
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={currencySelect.loading}
                    >
                      {currencySelect.data.map(({ text, value, id }) => (
                        <Select.Option key={value} value={`${id}`}>
                          {text}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              {/* 
              <Row>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="operationTypeString" label="İşlem Tipi :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="Tümü"
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                    >
                      <Select.Option key={1} value={"Satış"}>
                        Satış
                      </Select.Option>
                      <Select.Option key={2} value={"İade"}>
                        İade
                      </Select.Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row> */}

              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                  >
                    Sıfırla
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                    htmlType="submit"
                  >
                    Filtrele
                  </Button>
                </Col>
              </Row>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
};
export default ErpPosReportTransactionFilter;
